/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Magnet } from '../../models/magnet';

export interface MagnetGetMagnet$Params {

/**
 * GUID of the magnet
 */
  magnetId: string;
}

export function magnetGetMagnet(http: HttpClient, rootUrl: string, params: MagnetGetMagnet$Params, context?: HttpContext): Observable<StrictHttpResponse<Magnet>> {
  const rb = new RequestBuilder(rootUrl, magnetGetMagnet.PATH, 'get');
  if (params) {
    rb.path('magnetId', params.magnetId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Magnet>;
    })
  );
}

magnetGetMagnet.PATH = '/magnet/{magnetId}';
